module.exports = __webpack_public_path__ + "static/media/gif-ptbr.f794d16e.gif";